import React, { useState, useEffect, useCallback } from 'react';
import { IconButton } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDropzone } from 'react-dropzone';
import { useRestApi } from 'context/RestApiContext';

function MeetingFileImport(props) {
  const baseUrl = process.env.REACT_APP_REST_URL ?? '';
  const restApi = useRestApi();
  const [fileName, setFileName] = useState(props.fileName);
  const [fileSize, setFileSize] = useState(props.fileSize);

  // ドロップ処理
  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];

    // 拡張子がpdfかチェック
    const allowedExtensions = ['pdf'];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    // if (!allowedExtensions.includes(fileExtension)) {
    //   props.setDialog({
    //     type: 'error',
    //     message: 'PDFファイルをアップロードしてください',
    //   });
    //   return;
    // }

    // アップロード処理
    restApi.postUpload(`/api/meeting_history/upload/${file.name}`, file, (fileInfo) => {
      const fileSize = Math.round(fileInfo.FILE_SIZE);
      setFileName(fileInfo.FILE_NAME);
      setFileSize(fileSize);
      props.setFileInfo(fileInfo.FILE_NO);
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  // ファイルの削除処理
  const handleFileRemove = () => {
    setFileName(null);
    props.setFileInfo(0);
  };

  useEffect(() => {
    if (props?.params?.show) {
      setShow(true);
    }
  }, [props.params]);

  return (
    <>
      {fileName ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px',
            height: '72px',
            border: '2px solid #ccc',
            borderRadius: '16px',
          }}
        >
          <DescriptionOutlinedIcon fontSize="large" style={{ marginRight: '10px' }} />
          <div style={{ flexGrow: 1 }}>
            <p style={{ margin: 0 }}>{fileName}</p>
            <p style={{ margin: 0, fontSize: '12px', color: '#555' }}>{fileSize} KB</p>
          </div>
          <IconButton aria-label="delete" onClick={handleFileRemove}>
            <DeleteIcon />
          </IconButton>
        </div>
      ) : (
        <div
          {...getRootProps()}
          style={{
            border: '2px dashed #ccc',
            borderRadius: '16px',
            padding: '10px',
            textAlign: 'left',
            verticalAlign: 'middle',
            height: '72px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>ここにファイルをドロップしてください...</p>
          ) : (
            <p>ファイルをドラッグ&ドロップするか、ここをクリックしてファイルを選択してください</p>
          )}
        </div>
      )}
    </>
  );
}

export default MeetingFileImport;
